<template>
  <div
    class="border border-dark-60 flex flex-col"
    id="coros-calender"
    ref="corosCalender"
  >
    <svg class="svg-score-gradient">
      <!-- 水平渐变 -->
      <defs>
        <linearGradient
          id="linear"
          x1="100%"
          y1="100%"
          x2="0%"
          y2="0%"
        >
          <!-- 设置渐变色，使用stop标签 -->
          <stop
            offset="0%"
            stop-color="#5B6CA1"
            stop-opacity=""
          />
          <stop
            offset="100%"
            stop-color="#415283"
            stop-opacity=""
          />
        </linearGradient>
      </defs>
    </svg>
    <!-- 渲染表头 -->
    <ul class="table-header flex flex-row divide-x divide-dark-60 border-b border-border-1">
      <li
        v-for="(item, index) in columns"
        :key="index"
        class="flex-1 px-10 py-5 text-text-3 bg-bg-2"
      >
        {{ $t(item.title) }}
      </li>
    </ul>
    <!-- outer-class="table-body h-full flex-1 overflow-y-scroll" -->
    <Scrollbar
      class="table-body h-full flex-1 overflow-y-scroll"
      :style="{ height: height + 'px', overflow: 'auto' }"
      :class="[
        copying ? 'calender-day-hover-active' : 'calender-day-hover-unactive',
        weekCopying ? 'calender-week-hover-active' : 'calender-week-hover-unactive'
      ]"
      @scroll.native="handleScroll"
      id="table-body"
    >
      <!-- 行 -->
      <div
        v-for="(item, weekIndex) in data"
        :key="weekIndex"
        :ref="'week-' + weekIndex"
        :id="'week-' + weekIndex"
        class="calender-week-tr flex-1 text-text-3 flex flex-row divide-x divide-dark-60 table-tr border-t border-dark-60 relative"
        :class="[weekCopying && (showWeekDeleteBtn(item) ? 'calender-week-tr-activeable' : '')]"
      >
        <!-- 日卡片 -->
        <div
          v-for="(item1, dayIndex) in item"
          :key="dayIndex"
          @click="handleTableClick"
          :id="item1.rowGroupId"
          class="flex-1 text-text-3 table-td calender-week-day relative"
          :class="[
            item1.putable ? 'copy-enabled' : 'copy-disabled',
            item1.sports && item1.sports.length >= props.dayLimit ? 'copy-full' : 'copy-unfull'
          ]"
        >
          <Spin
            :loading="item1.loading"
            class="flex w-full h-full"
          >
            <div
              class="w-full h-full flex flex-col calender-day"
              :data-weekindex="weekIndex"
              :data-dayindex="dayIndex"
            >
              <template v-if="item1.dateType === 'weekday'">
                <div
                  class="calender-day-header px-10 border-b border-dark-60"
                  :id="item1.happenDay"
                  :class="[item1.isToday ? 'bg-current text-white current-date' : 'text-text-3 ']"
                >
                  {{ item1.DATE }}
                </div>
                <div
                  :id="['calender-day-body-' + item1.happenDay]"
                  :data-dayindex="dayIndex"
                  :data-weekindex="weekIndex"
                  data-from="schedule"
                  class="calender-day-body relative flex-1 flex flex-col"
                >
                  <Draggable
                    class="px-5 py-5 flex-1 flex flex-col dropzone"
                    :class="['putable-' + item1.putable]"
                    ghost-class="ghost"
                    drag-class="card-draging"
                    draggable=".card-dragable"
                    item-key="index"
                    :sort="false"
                    tag="div"
                    :group="{
                      name: 'people-' + (weekIndex * 7 + dayIndex),
                      pull: true,
                      put: item1.putable && item1.sports.length < item1.limit && hasEditPermission,
                      sort: false
                    }"
                    :model-value="item1.sports"
                    :set-data="handleDragData"
                    @add="handleDragAdd"
                    :move="handleDragMove"
                    @end="handleDragEnd"
                  >
                    <template #item="{ element, index }">
                      <div
                        class="mb-5 rounded-sm calender-day-card-item overflow-hidden relative"
                        :class="[
                          `card-${element.childType || 'special'}`,
                          `card-${element.cardType}`,
                          hasEditPermission && !element.thirdParty && isNormalProgram(element) && isNotPlanExpired(element)
                            ? `card-dragable`
                            : 'card-undragable',
                          item1.thirdParty ? 'thirdParty' : 'offical',
                          isNormalProgram(element) ? 'normal' : 'special',
                          isNotPlanExpired(element) ? 'plan-validate' : 'plan-expired'
                        ]"
                        :data-st="element.sportType"
                        :data-type="element.dataType"
                        :data-id="element.id"
                        :data-childindex="index"
                        data-from="schedule"
                      >
                        <ScoreTag
                          :hover-lock="hoverLock"
                          :item="element"
                        ></ScoreTag>
                        <!-- 卡片label标题 -->
                        <div class="text-12 px-10 flex pt-0 flex-row justify-between card-title items-center">
                          <!-- 图标 -->
                          <div class="sport-type-icon">
                            <template v-if="element.iconConfig">
                              <span
                                class="text-20"
                                :class="[element.iconConfig.icon]"
                                :style="{ color: element.iconConfig.color }"
                              ></span>
                            </template>
                          </div>
                          <!-- {{ element.thirdParty }} -->
                          <div
                            v-if="hasEditPermission && !showTeamLocker(element) && !element.copying && !readonly && canEdit"
                            class="flex flex-row"
                          >
                            <!-- 删除 -->
                            <span
                              v-if="showDayDelete(element)"
                              class="iconfont hidden cursor-pointer icon-delete iconicon_jichutubiao_shanchu1 text-16 text-text-3 hover:text-white"
                              @click="deletePlan(weekIndex, dayIndex, index, element.dataType)"
                            />
                            <!-- 复制 -->
                            <span
                              v-if="showCopy(element)"
                              @click="startCopyPlan(weekIndex, dayIndex, index, element.dataType)"
                              class="iconfont ml-10 hidden cursor-pointer icon-copy iconicon_jichutubiao_fuzhi1 text-16 text-text-3 hover:text-white"
                            />
                            <span
                              v-if="showUserLocker(element)"
                              class="iconfont ml-10 hidden cursor-pointer icon-lock iconicon_jichutubiao_suoding text-16 text-text-3 hover:text-white"
                            />
                          </div>
                          <div v-if="showTeamLocker(element)">
                            <span
                              class="iconfont ml-10 hidden cursor-pointer icon-lock iconicon_jichutubiao_suoding text-16 text-text-3 hover:text-white"
                            />
                          </div>
                          <div
                            v-if="element.copying"
                            class="schedule-card-copying-label text-12 text-center"
                          >
                            {{ $t('R8010') }}
                          </div>
                        </div>
                        <!-- card主体 -->
                        <div class="text-white px-10 text-12 leading-normal pb-14">
                          <div
                            class="text-14 font-medium hover:underline underline-offset-4 cursor-pointer leading-normal mb-5 break-normal line-ellispsis-2"
                            :class="[element.cardType === 'competition' && !item1.putable ? 'hover:no-underline' : '']"
                            @click="openEditModal(weekIndex, dayIndex, index)"
                            >{{ $t(element.name) }}</div
                          >
                          <!-- 细项 -->
                          <template v-if="element.cardType !== 'competition'">
                            <div
                              v-for="(item3, index3) in element.listItem"
                              :key="index3"
                              class="card-desc-label1 leading-relaxed font-medium"
                            >
                              <template v-if="element.childType != 'planFuture' && element.childType != 'planMiss'">
                                <span
                                  v-if="item3.sport_value"
                                  class="text-white"
                                >
                                  {{ item3.sport_value }}
                                </span>
                              </template>
                              <span
                                v-if="
                                  item3.sport_value &&
                                  item3.program_value &&
                                  element.childType != 'planFree' &&
                                  element.childType != 'planFuture' &&
                                  element.childType != 'planMiss'
                                "
                                class="text-text-3"
                              >
                                /
                              </span>
                              <span
                                v-if="element.childType != 'planFree'"
                                class="text-text-3"
                                >{{ item3.program_value }}</span
                              >
                            </div>

                            <div
                              v-if="element.cardType == 'entities'"
                              class="text-text-3 mt-5 whitespace-pre-wrap card-desc"
                            >
                              {{ $t(element.overview) }}
                            </div>
                          </template>
                        </div>
                        <!-- 柱状图 -->
                        <CardChart
                          v-if="element.chartHeight"
                          :chart="element.exerciseBarChart"
                        ></CardChart>
                      </div>
                    </template>
                    <template
                      #footer
                      v-if="hasEditPermission && item1.putable && item1.sports.length < item1.limit && currentTotals < maxLimit && canEdit"
                    >
                      <Popover
                        trigger="click"
                        :popup-visible="item1.popover"
                        position="right"
                        :click-outside-to-close="true"
                        content-class="add-card-popover"
                        :popup-container="'#calender-day-body-' + item1.happenDay"
                        @popup-visible-change="handlePopoverChange"
                      >
                        <div
                          @click="toggleAddPopover(weekIndex, dayIndex)"
                          class="add-card border rounded-sm border-primary-4 hidden py-10 flex-1"
                        >
                          <span
                            class="iconfont iconxinzeng text-30 cursor-pointer text-primary-6"
                            :class="['popover-' + item1.popover]"
                          />
                        </div>
                        <template #title>
                          <div class="title flex flex-row justify-between">
                            <div>{{ $t(`TG1011`) }}</div>
                            <i
                              class="iconfont text-text-2 hover:text-text-1 iconicon_jichutubiao_guanbi text-16 cursor-pointer"
                              @click="closePopover(weekIndex, dayIndex)"
                            />
                          </div>
                        </template>
                        <template #content>
                          <ul class="add-card-popover-body py-5">
                            <li
                              v-for="(optItem, optIndex) in add_template_options"
                              :key="optIndex"
                              class="cursor-pointer text-14 text-white hover:text-primary-6 py-5 flex flex-row justify-start whitespace-pre"
                              @click="openAddModal(optItem.value, weekIndex, dayIndex)"
                            >
                              <span
                                class="iconfont mr-8 text-16"
                                :class="[optItem.icon]"
                              />
                              <span>{{ $t(optItem.label) }}</span>
                            </li>
                          </ul>
                        </template>
                      </Popover>
                    </template>
                  </Draggable>
                  <!-- 新增框 -->
                </div>
              </template>
              <!-- 周总结 -->
              <div
                v-else
                class="relative flex-1 flex flex-col justify-start items-start"
              >
                <!--选择项  -->
                <div
                  :id="`stage-${weekIndex}-${dayIndex}`"
                  class="calender-day-header relative w-full flex items-center border-b border-dark-60"
                >
                  <Select
                    size="mini"
                    :model-value="`${weekIndex}-${dayIndex}-${item1.stage - 1}`"
                    :disabled="readonly"
                    @change="handleStageChange"
                    :placeholder="$t('R3002')"
                    :popup-container="`#stage-${weekIndex}-${dayIndex}`"
                    :fallback-option="false"
                    :class="['coros-stage-select', 'h-full rounded-none border-none', 'coros-stage-' + item1.stage]"
                    :style="{
                      '--var-weekstage-color': week_stage_options_map[item1.stage].color,
                      '--var-weekstage-background-color': week_stage_options_map[item1.stage].bg
                    }"
                  >
                    <template #label="{ data }">
                      <span>{{ data.label }}</span>
                    </template>
                    <Option
                      v-for="(option, optIndex) in week_stage_options"
                      :key="optIndex"
                      :value="`${weekIndex}-${dayIndex}-${optIndex}`"
                      :class="['weekstage-option', option.label]"
                      :style="{
                        '--var-weekstage-color': option.color,
                        '--var-weekstage-background-color': option.bg
                      }"
                    >
                      {{ $t(option.label) }}
                    </Option>
                  </Select>
                </div>
                <div class="flex-1 flex w-full calender-day-content flex-col justify-between items-start">
                  <!-- 总结明细 -->
                  <WeekStage
                    class="w-full flex-1"
                    :stage-info="item1"
                    :from="from"
                  ></WeekStage>
                  <div class="operate-week-btns-wrapper flex-flex-row w-full h-[50px]">
                    <div
                      class="operate-week-btns flex flex-row w-full justify-end items-center"
                      v-show="!copying"
                    >
                      <div
                        v-if="hasEditPermission"
                        class="flex flex-start items-center px-10"
                      >
                        <div
                          v-if="showWeekDeleteBtn(item)"
                          class="cursor-pointer hover:text-primary-6 py-10 px-5"
                          @click="deleteWeek(weekIndex)"
                        >
                          <!-- 删除 -->
                          <i class="iconfont iconicon_jichutubiao_shanchu1 text-18"></i>
                        </div>
                        <!-- 复制 -->
                        <div
                          class="cursor-pointer hover:text-primary-6 py-10 px-5"
                          @click="startCopyWeek(weekIndex)"
                        >
                          <i class="iconfont iconicon_jichutubiao_fuzhi1 text-18"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Spin>
          <!-- 按天复制悬浮遮罩 -->
          <div
            v-if="copying"
            class="calender-week-day-copy__hover"
          >
            <div class="flex flex-col items-center">
              <Button
                class="copy-action-button paste-btn mt-50 w-1/2"
                shape="round"
                type="primary"
                @click="handleCopy(weekIndex, dayIndex)"
                >{{ $t(`R3007`) }}</Button
              >
              <Button
                class="copy-action-button cancel-btn mt-10 w-1/2"
                shape="round"
                @click="cancelCopy(weekIndex, dayIndex)"
                >{{ $t(`C1006`) }}</Button
              >
            </div>
          </div>
          <!-- 按天复制达到上限 -->
          <div
            v-if="copying"
            class="calender-week-day-limited__hover"
          >
            <Trigger
              :trigger="['hover']"
              auto-fit-position
              align-point
              show-arrow
            >
              <div class="limit-tooltip-container"></div>
              <template #content>
                <div class="demo-point bg-dark-400 text-white px-10 py-5 rounded-sm">
                  {{ $t('R9010') }}
                </div>
              </template>
            </Trigger>
          </div>
        </div>
        <!-- 按周复制遮罩 -->
        <div
          v-if="weekCopying"
          class="calender-week-copy__hover"
        >
          <div class="flex justify-center">
            <div class="flex flex-col justify-center">
              <Button
                class="copy-action-button paste-btn mt-50 flex-item w-160"
                shape="round"
                type="primary"
                @click="handleWeekCopy(weekIndex)"
                >{{ $t(`R3007`) }}</Button
              >
              <Button
                class="copy-action-button cancel-btn mt-10 flex-item w-160"
                shape="round"
                @click="cancelWeekCopy"
                >{{ $t(`C1006`) }}</Button
              >
            </div>
          </div>
        </div>
      </div>
    </Scrollbar>
  </div>
</template>
<script setup>
import { ref, computed } from 'vue';
import { Select, Option, Spin, Modal, Popover, Button, Scrollbar, Trigger } from '@arco-design/web-vue';
import CardChart from '../components/cardChart/index.vue';
import { WEEK_STAGE_OPTIONS, ADD_TEMPLATE_OPTION, WEEK_STAGE_OPTIONS_MAP } from './instance';
import Draggable from 'vuedraggable';

import { scheduleStore as scheduleStoreRef } from '@client/store/scheduleStore';
import { userStore as userStoreRef } from '@client/store/userStore';
import { memberDataStore as memberDataStoreRef } from '@client/store/memberDataStore';
import { useI18n } from 'vue-i18n';
import ScoreTag from '../components/scoreTag/index.vue';
import WeekStage from '../components/weekStage/index.vue';
import SportIcon from '@client/components/sportIcon/index.vue';
import queryString from 'query-string';
import { cloneDeep, throttle } from 'lodash';
import { isGroupHolder, isCoach } from '@client/helper';
const { t } = useI18n();
const scheduleStore = scheduleStoreRef();
const userStore = userStoreRef();
const memberDataStore = memberDataStoreRef();
import { useElementSize } from '@vueuse/core';
const corosCalender = ref(null);

const { height } = useElementSize(corosCalender);
const props = defineProps({
  columns: {
    type: Array,
    default: function () {
      return [];
    }
  },
  data: {
    type: Array,
    default: function () {
      return [];
    }
  },
  readonly: {
    type: Boolean,
    default: false
  },
  // 用于执行中的训练下, 教练给学员添加的训练, 学员不能编辑的权限处理
  canEdit: {
    type: Boolean,
    default: true
  },
  from: {
    type: String,
    default: 'schedule'
  },
  loadingBottom: {
    type: Boolean,
    default: false
  },
  loadingTop: {
    type: Boolean,
    default: false
  },
  teamId: {
    type: String,
    default: ''
  },
  userId: {
    type: String,
    default: ''
  },
  // 总数限制
  maxLimit: {
    type: Number,
    default: 99999
  },
  dayLimit: {
    type: Number,
    default: 10
  }
});
const emits = defineEmits([
  'dragadd',
  'deletePlan',
  'togglePopover',
  'openTemplateModal',
  'onScrollToBottom',
  'onScrollToTop',
  'deleteWeekPlan',
  'copyWeekPlan',
  'openEditModal',
  'openAddModal'
]);
/****************** 响应式数据 ************/
const hoverLock = ref(false);
const activeWeekCopyIndex = ref(-1);
const week_stage_options = ref(cloneDeep(WEEK_STAGE_OPTIONS));
const week_stage_options_map = ref(cloneDeep(WEEK_STAGE_OPTIONS_MAP));
const add_template_options = computed(() => {
  const options = [];
  ADD_TEMPLATE_OPTION.forEach((item, index) => {
    if (item.value === 'label') {
      if (scheduleStore.site === 'schedule') options.push(item);
    } else {
      options.push(item);
    }
  });
  return options;
});

const copying = ref(false);
const weekCopying = ref(false);
const initScrollTop = ref(0);
const safeLoadPadding = ref(300);

const handleScroll = throttle((e) => {
  const { scrollTop, scrollHeight, clientHeight } = e.target;
  // 判断方向
  if (scrollTop > initScrollTop.value) {
    const scrollBottom = scrollHeight - clientHeight - scrollTop;
    console.log('向下滚动');
    if (scrollBottom < safeLoadPadding.value) {
      console.log('向下加载更多');
      emits('onScrollToBottom');
    }
  } else {
    // 向上滚动
    console.log('向上滚动');
    if (scrollTop < safeLoadPadding.value) {
      console.log('向上加载更多');
      emits('onScrollToTop', { scrollTop, scrollHeight });
    }
  }
  initScrollTop.value = scrollTop;
}, 500);
// 当前运动总数
const currentTotals = computed(() => {
  let total = 0;
  props.data.forEach((weekItem) => {
    weekItem.forEach((dayItem) => {
      const { sports = [] } = dayItem;
      total += sports.length;
    });
  });
  return total;
});
const isMyself = computed(() => {
  if (!memberDataStore.teamViewMode) return true;
  return memberDataStore.isMyself;
});

const hasEditPermission = computed(() => {
  const { isMyself, teamViewMode,editPermission} = memberDataStore;
  if (isMyself) return true;

  if (!teamViewMode) return true;
  if (!memberDataStore.userData) return false;
  return editPermission
});
const isNormalProgram = (element) => {
  const { cardType } = element;
  return cardType !== 'competition' && cardType !== 'free' && cardType !== 'label';
};
const isNotPlanExpired = (element) => {
  const { childType } = element;
  if (childType === 'planMiss' || childType === 'planFuture') {
    return true;
  } else {
    return false;
  }
};
const showTeamLocker = (element) => {
  if (isMyself.value) return false;
  // 非正常运动, 不展示锁头
  if (!isNormalProgram(element)) return false;
  if (!hasEditPermission.value) return true;

  const { operateUserId, teamId, happenDay, userId, name } = element;
  if (operateUserId === userStore.userId) {
    // 添加者本人
    return false;
  }
  const isNotStudentSelf = operateUserId !== memberDataStore.userData.userId;
  const { viewerData } = memberDataStore;
  if (viewerData) {
    const isCoachRole = isGroupHolder(viewerData.role) || isCoach(viewerData.role);
    const isNotGroupHolderOrCoach = !findIsInTeamCoaching(operateUserId); // 不是这个队伍的教练
    const isNotSameTeam = props.teamId !== teamId;

    return isNotStudentSelf && isCoachRole && (isNotGroupHolderOrCoach || isNotSameTeam);
  } else {
    return true;
  }
};
const showUserLocker = (element) => {
  const { thirdParty, operateUserId } = element;
  if (isMyself.value) return false;
  if (thirdParty) return true;
  if (!isNormalProgram(element)) return false;
  // 是用户，或者开放编辑权限
  if (!hasEditPermission.value) return true;
  if (operateUserId === userStore.userId) {
    // 添加者本人
    return false;
  }
  // 开放编辑权限, 是教练
  const { viewerData, userData } = memberDataStore;
  const isCoachRole = isCoach(viewerData.role);

  if (!isCoachRole) return true;
  // 不是这个队伍的教练
  const isNotGroupHolderOrCoach = !findIsInTeamCoaching(operateUserId);
  if (!isNotGroupHolderOrCoach) return true;
  return false;
};
const hasOwner = (element) => {
  const { operateUserId } = element;
  return operateUserId === userStore.userId;
};
const showDayDelete = (element) => {
  const { operateUserId, cardType, happenDay, thirdParty, isBefore, childType } = element;
  const isOwner = hasOwner(element);

  if (thirdParty) {
    return false;
  }

  // 个人日程不允许删除教练课程
  if (!isOwner && props.from === 'schedule') return false;

  if (isMyself.value) return true;

  if (childType === 'planMiss' || childType === 'planOver' || childType === 'planFailed') {
    return false;
  }
  const { viewerData, userData } = memberDataStore;
  // 判断是否是创建者本人'=
  if (cardType === 'free') return false;
  const isTriangle = operateUserId !== userStore.userId;
  // 过去的训练计划, 仅限本人和创建者删除
  if (isBefore) {
    if (isTriangle) {
      // 创建者本人
      return false;
    }
    return true;
  }
  // 未来的计划, 仅限本人及创建者
  // 第三方计划教练无权操作删除，仅限本人操作
  const isCoachRole = isGroupHolder(viewerData.role) || isCoach(viewerData.role);
  // 教练或群主可操作
  const editable = userData.userProfile.allowCoachEditing === 1;
  return !isTriangle && isCoachRole && editable;
};
const showCopy = (element) => {
  if (!isNormalProgram(element)) return false;
  if (isMyself.value) return true;
  const { operateUserId } = element;

  const isThirdAuthor = operateUserId !== userStore.userId && operateUserId !== props.userId;

  if (isThirdAuthor) return false;
  // 教练或群主可操作
  const viewerData = memberDataStore.viewerData;
  const isGroupHolderOrCoach = isGroupHolder(viewerData.role) || isCoach(viewerData.role);

  if (isGroupHolderOrCoach) return true;
  return false;
};
// 是否是当前团队的教练，true是，false不是
const findIsInTeamCoaching = (id) => {
  const { activeTeamCoachList = [], activeTeamUserList = [] } = memberDataStore;
  const teamList = [...activeTeamCoachList, ...activeTeamUserList];
  const tick = teamList.findIndex((m) => {
    return m.userId === id && m.role !== 3;
  });

  return tick > -1;
};
const handleDragEnd = () => {
  Array.from(document.getElementsByClassName('dropzone')).forEach((element) => {
    element.classList.remove('dropzone--over');
  });
};
const handleDragMove = (event) => {
  console.log('move');
  Array.from(document.getElementsByClassName('dropzone')).forEach((element) => {
    element.classList.remove('dropzone--over');
  });
  event.to.classList.add('dropzone--over');
};
const handleDragData = (dataTransfer, el) => {
  // const id = el.getAttribute('data-id');
  // const matchedItem = trainingGroups.value.find((item) => item.id === id);
  // dataTransfer.setData('data-string', JSON.stringify(matchedItem));
};
const handleDragAdd = (el) => {
  if (props.readonly) return;
  emits('dragadd', el);
};
const openAddModal = (type, weekIndex, dayIndex) => {
  if (props.readonly) return;

  emits('openAddModal', { type, weekIndex, dayIndex });
};
const openEditModal = (weekIndex, dayIndex, index) => {
  const item = props.data[weekIndex][dayIndex].sports[index];
  const { teamId, userId } = props;
  const { dataType, childType, labelId, sportData, sportType } = item;
  if (['planFailed', 'planReach', 'planOver', 'planFree'].includes(childType)) {
    const query = {
      labelId,
      sportType
    };
    if (teamId) {
      query.teamId = teamId;
      query.userId = userId;
    }
    // 跳转到运动详情
    const href = queryString.stringifyUrl({ url: `${location.origin}/activity-detail`, query });
    window.open(href);
    return;
  }
  emits('openEditModal', { weekIndex, dayIndex, index });
};
const handleTableClick = () => {};
const toggleAddPopover = (weekIndex, dayIndex) => {
  if (props.readonly) return;

  emits('togglePopover', { weekIndex, dayIndex });
};
const closePopover = (weekIndex, dayIndex) => {
  emits('closePopover', weekIndex, dayIndex);
};
const handlePopoverChange = (status) => {
  const { weekIndex, dayIndex } = scheduleStore.activeCalendCardData;
  if (!status) {
    emits('closePopover', weekIndex, dayIndex);
  }
};
const handleStageChange = (indexStr) => {
  const arr = indexStr.split('-');
  const [weekIndex, dayIndex, value] = arr;
  console.log(weekIndex, dayIndex, value);
  // stage 从1 开始
  emits('onStageChange', { weekIndex, dayIndex, value: Number(value) + 1 });
};
// 复制
const startCopyPlan = (weekIndex, dayIndex, index, type) => {
  copying.value = true;
  const { happenDay } = props.data[weekIndex][dayIndex];
  // scheduleStore.updateCalendCardData({ weekIndex, dayIndex, index, type, happenDay });
  emits('onCopy', { weekIndex, dayIndex, index, type, happenDay });
};
// 删除
const deletePlan = (weekIndex, dayIndex, index, type) => {
  if (props.readonly) return;
  // 弹出确认
  let content = t('R9001');
  if (type === 'label') {
    content = t('R9002');
  }
  Modal.confirm({
    titleAlign: 'start',
    content,
    title: t('C5004'),
    okText: t('C1005'),
    cancelText: t('C1006'),
    modalClass: 'coros-modal-footer-right',
    onOk: () => {
      // 执行删除
      emits('deletePlan', { weekIndex, dayIndex, index, type });
    }
  });
};
const handleCopy = (weekIndex, dayIndex) => {
  copying.value = false;
  emits('onCopyConfirm', { weekIndex, dayIndex });
};
const cancelCopy = () => {
  copying.value = false;
  emits('cancelCopy');
};
const handleWeekCopy = (weekIndex) => {
  weekCopying.value = false;
  emits('onCopyWeekConfirm', { fromWeekIndex: activeWeekCopyIndex.value, toWeekIndex: weekIndex });
  activeWeekCopyIndex.value = -1;
};
const cancelWeekCopy = () => {
  weekCopying.value = false;
  activeWeekCopyIndex.value = -1;
};
const showWeekDeleteBtn = (weekItem) => {
  for (let i = 0; i < weekItem.length; i++) {
    const item = weekItem[i];
    if (item.dateType == 'weekday' && !item.isBefore) {
      return true;
    }
  }
  return false;
};
const deleteWeek = (weekIndex) => {
  // 弹出确认框
  Modal.confirm({
    titleAlign: 'start',
    content: t('R1106'),
    title: t('C5004'),
    okText: t('C1005'),
    cancelText: t('C1006'),
    modalClass: 'coros-modal-footer-right',
    onOk: () => {
      // 执行删除
      emits('deleteWeekPlan', { weekIndex });
    }
  });
};
const startCopyWeek = (weekIndex) => {
  activeWeekCopyIndex.value = weekIndex;
  weekCopying.value = true;
};
</script>
<style lang="scss">
@import '@client/styles/_mixins.scss';
.coros-calender {
  z-index: 9;
  .calender-week-day {
    width: 12.5%;
    flex: 0 0 12.5%;
  }
  .add-card {
    @apply flex;
    @apply flex-row;
    @apply justify-center;
    @apply items-center;
    opacity: 0;
  }
  .calender-day:hover {
    .add-card {
      opacity: 1;
    }
  }
  .calender-day-header {
    @apply bg-fill-5;
    height: px2rem144(32);
    line-height: px2rem144(32);
  }
  .calender-day-body {
    min-height: 150px;
    .putable-true {
      .ghost {
        display: none;
      }
    }
    .dropzone--over {
      box-sizing: border-box;
      // border: 1px solid red;
      box-shadow: inset 0 0 4px #00aaf2;
      .add-card {
        opacity: 0;
      }
    }
  }
 

  .calender-day-card-item:hover {
    .icon-delete,
    .icon-copy,
    .icon-lock {
      display: block;
    }
    .card-score-tag {
      display: none;
    }
  }

  .card-title {
    height: px2rem144(30);
    position: relative;
  }
  .bg-current {
    background-color: #465ea1;
  }

  .calender-day-card-item {
    @apply bg-dark-400;
  }
  .schedule-card-copying-label {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 99;
    background-color: #848890;
    color: #fff;
    border-radius: px2rem144(10) 0 0 px2rem144(10);
    left: px2rem144(40);
  }
  .card-label {
    background-color: #584c28;
  }

  .card-competition {
    @apply bg-yellow-600;
    @apply bg-opacity-50;
  }
  .card-planFuture {
    background-color: #1d2540;
  }
  .card-planFailed {
    background-color: #242a3b;
  }
  .card-planMiss {
    background-color: #242a3b;
  }
  .card-planReach {
    background-color: #242a3b;
  }
  .card-free {
    background-color: #242a3b;
  }
  .card-planOver {
    background-color: #242a3b;
  }
  .card-desc {
    color: rgba(255, 255, 255, 0.6);
    white-space: pre-wrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    word-break: break-word;
    -webkit-line-clamp: 10;
    /* autoprefixer: ignore next */
    -webkit-box-orient: vertical;
  }
}
.weekstage-option {
  &:hover {
    color: var(--var-weekstage-color) !important;
    background-color: var(--var-weekstage-background-color) !important;
  }
}
.coros-stage-select {
  color: var(--var-weekstage-color) !important;
  background-color: var(--var-weekstage-background-color) !important;
}

.add-card-popover {
  min-width: 128px;
}
.copy-action-button {
  &.cancel-btn {
    background-color: #484f61;
    &:hover {
      background-color: #535968;
    }
  }
}

.calender-week-day-copy__hover {
  display: none;
}
.calender-week-day-limited__hover {
  display: none;
}
.calender-day-hover-active {
  .calender-week-day.copy-enabled.copy-unfull {
    &:hover {
      .calender-week-day-copy__hover {
        display: block;
        background-color: rgba(0, 170, 242, 0.2);
        border: 1px solid #00aaf2;
        z-index: 100;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }
    }
  }
}
.calender-day-hover-active {
  .calender-week-day.copy-enabled.copy-full {
    &:hover {
      .calender-week-day-limited__hover {
        display: block;
        background-color: rgba(0, 170, 242, 0);
        border: 1px solid #000;
        z-index: 100;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }
    }
  }
}
.calender-week-copy__hover {
  display: none;
}
.calender-week-hover-active {
  .calender-week-tr-activeable {
    &:hover {
      .calender-week-copy__hover {
        display: block;
        background-color: rgba(0, 170, 242, 0.2);
        border: 1px solid #00aaf2;
        z-index: 100;
        position: absolute;
        top: 0;
        left: 0;
        right: 12.5%;
        bottom: 0;
      }
    }
  }
}
.limit-tooltip-container {
  width: 100%;
  height: 100%;
}
.card-score-tag {
  // background: linear-gradient(188deg, #5b6ca1 0%, #415283 100%);
  position: absolute;
  display: flex;
  top: 0;
  right: 0;
  z-index: 2;
  color: #fff;
  // height: 20px;
  border-top-right-radius: 2px;
  overflow: hidden;
  // line-height: 20px;
  font-size: 14px;
  font-weight: 500;
}
.calender-day-content {
  .operate-week-btns {
    visibility: hidden;
  }
  &:hover {
    .operate-week-btns {
      display: flex;
      visibility: visible;
    }
  }
}
</style>
